<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="960px"
    @keydown.esc="closeDialog"
  >
    <v-card id="attendingInfo">
      <div
        class="popup-container"
        style="width: 960px; min-width: 960px; background: #464775"
        v-if="meeting"
      >
        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            height: 50px;
            align-items: center;
            margin: 0 20px;
          "
        >
          <p style="color: white; font-size: 20px;">회의 참여 정보</p>
          <img
            style="width: 22px; cursor: pointer"
            src="/static/img/close_bt.png"
            @click="closeDialog"
          />
        </div>

        <div
          class="tbw_tb01 dataTable detail"
          style="width: auto; margin-left: 0; margin: 15px; margin-top: 0"
        >
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div style="padding-top: 5px; float: left; margin-bottom: 10px">
              <span style="font-weight: normal; font-size: 16px; color: #333"
                >회의제목 :
              </span>
              <span style="font-weight: normal; font-size: 16px; color: #333">{{
                meeting.title
              }}</span>
            </div>
            <img
              src="/static/seoul/img/excel.png"
              style="width: 24px; cursor: pointer; margin-right: 5px"
              @click="exportHistoryList()"
            />
          </div>
          <div v-if="meeting.conferenceRoomActive === true" style="clear: both">
            <div
              class="history-info-btn"
              @click="changeActive('attendee')"
              :class="active === 'attendee' ? 'btn-active' : ''"
            >
              {{ $t('page.statistics.history.attendees') }}
            </div>
            <!-- <div class="history-info-btn" @click="changeActive('codec')" :class="active==='codec' ? 'btn-active' : ''">
            {{ $t('page.statistics.history.codec') }}
          </div> -->
          </div>
          <div v-if="active === 'attendee'">
            <table>
              <caption>
                참석자 리스트
              </caption>
              <thead>
                <tr>
                  <th>유형</th>
                  <th>이름</th>
                  <th>부서</th>
                  <th>연결 상태</th>
                  <th>참여 시각</th>
                  <th>나간 시각</th>
                  <th>참여시간(분)</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(listItem, index) in filterLimitAttendees"
                  :key="index"
                >
                  <td>
                    {{
                      listItem['history:type']
                        ? listItem['history:type'].toUpperCase()
                        : '-'
                    }}
                  </td>
                  <td>
                    {{
                      listItem['history:displayName']
                        ? listItem['history:displayName']
                        : listItem['history:name']
                    }}
                  </td>
                  <td>{{ listItem['history:department'] }}</td>
                  <td
                    class="text-xs-center"
                    :style="
                      listItem['joinTime']
                        ? 'color:rgb(0, 120, 212)'
                        : 'color:#464775'
                    "
                  >
                    {{ listItem['history:joinTime'] ? `참여` : `미참여` }}
                  </td>
                  <td>
                    {{
                      listItem['history:joinTime'] | conferenceTimeFilter
                    }}
                  </td>
                  <td>
                    {{
                      listItem['history:leaveTime'] | conferenceTimeFilter
                    }}
                  </td>
                  <td>{{ displayMinutes(listItem['history:duration']) }}</td>
                </tr>
              </tbody>
            </table>
            <!--//tbw_tb01-->
            <div class="paging" style="margin-top: 10px">
              <div class="boardnavi">
                <pagination
                  :records="attendees.length"
                  v-model="page"
                  :per-page="perPage"
                />
              </div>
            </div>
          </div>
          <div v-if="active === 'codec'">
            <table>
              <caption>
                참석자 리스트
              </caption>
              <thead>
                <tr>
                  <th>회의실 이름</th>
                  <th>연결 상태</th>
                  <th>참여 시각</th>
                  <th>나간 시각</th>
                  <th>참여시간(분)</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(listItem, index) in filterLimitCodecAttendees"
                  :key="index"
                >
                  <td>{{ listItem['roomName'] }}</td>
                  <td
                    class="text-xs-center"
                    :style="
                      listItem['joinTime']
                        ? 'color:rgb(0, 120, 212)'
                        : 'color:#464775'
                    "
                  >
                    {{ listItem['joinTime'] ? `참여` : `미참여` }}
                  </td>
                  <td>
                    {{
                      listItem['joinTime'] | conferenceTimeFilter
                    }}
                  </td>
                  <td>
                    {{
                      listItem['leaveTime'] | conferenceTimeFilter
                    }}
                  </td>
                  <td>{{ displayMinutes(listItem['duration']) }}</td>
                </tr>
              </tbody>
            </table>
            <!--total_num-->
            <div class="total_num" style="margin-right: 28px">
              <p class="fl" style="padding-top: 5px">
                <span>Rows per page :</span
                ><span style="padding-right: 10px">{{ perPage }}</span
                ><span>Total :</span><span>{{ codecAttendees.length }}</span>
              </p>
            </div>
            <!--total_num-->
            <!--//tbw_tb01-->
            <div class="paging">
              <div class="boardnavi">
                <pagination
                  :records="codecAttendees.length"
                  v-model="page"
                  :per-page="perPage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from '@/util';
import moment from 'moment';
import Pagination from 'vue-pagination-2';

export default {
  filters: {
    conferenceDayFilter: function (day) {
      if (day === null) {
        return moment().format('YYYY / MM / DD');
      } else {
        return moment(day).format('YYYY / MM / DD');
      }
    },
    conferenceTimeFilter: function (time) {
      return moment(time).format('YY.MM.DD HH:mm:ss');
    },
    textLengthOverCut (txt, len, lastTxt) {
      if (len === '' || len === null) { 
        len = 5;
      }
      if (lastTxt === '' || lastTxt === null) { 
        lastTxt = '...';
      }
      console.log(txt.length);
      console.log(len);
      if (txt.length > len) {
        txt = txt.substr(0, len) + lastTxt;
        console.log(txt);
      }
      return txt;
    }
  },
  components: {
    Pagination,
  },
  props: ['dialog', 'meeting', 'closeDialog'],
  data() {
    return {
      page: 1,
      perPage: 6,
      active: 'attendee',
      loading: true,
      attendees: [],
      codecAttendees: [],
    };
  },
  computed: {
    computeLogo() {
      return '/static/images/info_icon.png';
    },
    filterLimitAttendees() {
      let page = this.page;
      let startPage = (page - 1) * this.perPage;
      let limitPage = startPage + this.perPage;

      return this.attendees.slice(startPage, limitPage);
    },
    filterLimitCodecAttendees() {
      let page = this.page;
      let startPage = (page - 1) * this.perPage;
      let limitPage = startPage + this.perPage;

      return this.codecAttendees.slice(startPage, limitPage);
    },
  },
  watch: {
    dialog: {
      async handler(val) {
        if (val) {
          await this.initHistoryList();
        }
      },
    },
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    async addPeople() {
      /* 추가초대 버튼 Func */
      console.log('addPeople');
    },
    async initHistoryList() {
      this.meeting.history.map( el => {
        if (el['history:type'] === 'codec') {
          el['history:type'] = '영상회의실';
        }
      });
      this.attendees = this.meeting.history.filter(
        (h) => h[`type`] !== 'codec'
      );
      this.codecAttendees = this.meeting.history.filter(
        (h) => h[`type`] === 'codec'
      );
      // conferenceRoomActive 인 경우 코덱 참여자 체크
      // this.codecAttendees = this.meeting.history.filter(h => h['history:clientAgent'] && h['history:clientAgent'].toUpperCase().includes('VIDEO DEVICE') || h['history:clientAgent'].toUpperCase().includes('WEBEX ROOM'));
    },
    changeActive(type) {
      if (this.active !== type) {
        this.page = 1;
      }
      this.active = type;
    },
    displayMinutes(duration) {
      try {
        if (duration) {
          return Math.round(Number(duration) / 60);
        }
      } catch (err) {
        console.log(err);
        return duration;
      }
    },
    calJoinPercent(meeting) {
      let ret =
        Math.round(
          (meeting.analytics.actualAttendees / meeting.analytics.attendees) *
            10000
        ) / 100;
      if (isNaN(ret)) {
        return ``;
      } else {
        return ret;
      }
    },
    exportHistoryList() {
      if (this.active === 'attendee') {
        // Export
        let columns = [
          { header: `유형`, key: 'type', width: 25 },
          { header: `이름`, key: 'name', width: 25 },
          { header: `부서`, key: 'dept', width: 30 },
          { header: `연결 상태`, key: 'status', width: 15 },
          { header: `참여 시각`, key: 'joinTime', width: 20 },
          { header: `나간 시작`, key: 'leaveTime', width: 20 },
          { header: `참여시간(분)`, key: 'duration', width: 20 },
        ];

        let items = [];
        this.attendees.forEach((h) => {
          let joinTime = '';
          if (h['joinTime']) {
            joinTime = moment(h['joinTime']).format('YY-MM-DD HH:mm:ss');
          } else if (h['history:joinTime']) {
            joinTime = moment(h['history:joinTime']).format(
              'YY-MM-DD HH:mm:ss'
            );
          }

          let leaveTime = '';
          if (h['leaveTime']) {
            leaveTime = moment(h['leaveTime']).format('YY-MM-DD HH:mm:ss');
          } else if (h['history:leaveTime']) {
            leaveTime = moment(h['history:leaveTime']).format(
              'YY-MM-DD HH:mm:ss'
            );
          }

          items.push({
            type: h['history:type'] ? h['history:type'].toUpperCase() : '-',
            name: h['history:displayName'] || h['history:email'],
            dept: h['history:department'],
            status: h['joinTime'] || h['history:joinTime'] ? `참여` : `미참여`,
            joinTime: joinTime,
            leaveTime: leaveTime,
            duration: this.displayMinutes(h['history:duration']),
          });
        });
        Util.exportExcel(
          'History List',
          columns,
          items,
          true,
          'History List.xlsx'
        );
      }

      if (this.active === 'codec') {
        let columns = [
          { header: `회의실 이름`, key: 'name', width: 25 },
          { header: `연결 상태`, key: 'status', width: 15 },
          { header: `참여 시각`, key: 'joinTime', width: 20 },
          { header: `나간 시작`, key: 'leaveTime', width: 20 },
          { header: `참여시간(분)`, key: 'duration', width: 20 },
        ];

        let items = [];
        this.codecAttendees.forEach((h) => {
          let joinTime = '';
          if (h['joinTime']) {
            joinTime = moment(h['joinTime']).format('YY-MM-DD HH:mm:ss');
          } else if (h['history:joinTime']) {
            joinTime = moment(h['history:joinTime']).format(
              'YY-MM-DD HH:mm:ss'
            );
          }

          let leaveTime = '';
          if (h['leaveTime']) {
            leaveTime = moment(h['leaveTime']).format('YY-MM-DD HH:mm:ss');
          } else if (h['history:leaveTime']) {
            leaveTime = moment(h['history:leaveTime']).format(
              'YY-MM-DD HH:mm:ss'
            );
          }

          items.push({
            name: h['history:roomName'],
            status: h['joinTime'] || h['history:joinTime'] ? `참여` : `미참여`,
            joinTime: joinTime,
            leaveTime: leaveTime,
            duration: this.displayMinutes(h['history:duration']),
          });
        });
        Util.exportExcel(
          'History List',
          columns,
          items,
          true,
          'History List.xlsx'
        );
      }
    },
  },
};
</script>
<style scoped>
.popup-container {
  display: flex;
  flex-direction: column;
}
.meeting-info-title {
  width: 33%;
  text-align: center;
  line-height: 50px;
  font-size: 12pt;
}
.pop_top {
  font-weight: 600;
}
.user_list {
  margin: 20px 0;
  padding-left: 15px;
  padding-right: 15px;
}
.user_tit {
  text-align: center;
  margin: 40px 0 10px;
  font-size: 20px;
  font-weight: 600;
}

.pop_con > .box_2:nth-child(1) {
  margin-left: 35px;
}

.box_padding {
  padding: 0 10px 0 10px;
}

.pop_userList .user_tit {
  text-align: center;
  margin: 10px 0 20px 0;
  font-size: 20px;
  font-weight: 600;
}

#confernceRoom {
  margin-top: 50px;
}

.border_box {
  border: 1px solid #e8e8e8;
  min-height: 100px;
}

.dialog-footer-btn {
  background: #fff;
  color: #fa4242;
  width: 98px;
  height: 38px;
  border: 1px solid #fa4242;
  border-radius: 5px;
  text-align: center;
  display: inline-block;
  width: 100px;
  height: 40px;
  font-size: 12px;
  line-height: 40px;
  margin: 0 5px;
  padding: 0;
}
#addPeopleBtn {
  background-color: #c41e1b !important;
  color: white;
}
.tabContent {
  font-weight: 500;
}
.font-red {
  color: #fa4242;
}

.history-info-btn {
  width: 110px;
  height: 40px;
  border-radius: 7px;
  font-weight: 300;
  font-size: 15px;
  text-align: center;
  line-height: 40px;
  background: white;
  border: 1px solid #464775;
  cursor: pointer;
  color: #464775;
  float: left;
  /* margin-right: 8px;
    margin-top: 10px; */
  margin: 10px 8px 10px 0px;
}

.history-info-btn:hover {
  background-color: #464775;
  color: white;
}

.btn-active {
  background-color: #464775;
  color: white;
}

#attendingInfo .dataTable table td:nth-child(odd) {
  padding-left: 0;
}

#attendingInfo .tbw_tb01 table th {
  font-weight: bold;
  font-family: 'Noto Sans KR';
}

#attedingInfo {
}
</style>



// WEBPACK FOOTER //
// src/components/popup/AttendingInfoDialog.vue